<div class="team-performance-container">
    <div class="team-performance-title">
        <h3>Team Performance</h3>
        <div class="middle-line"></div>
    </div>
    <mat-tab-group>
        <mat-tab label="Cases">
            <div class="team-performance-tab">
                <!-- Average Cycle Time Chart -->
                <mat-card class="team-performance-chart" [ngClass]="{'expanded': expandedChart === 0, 'collapsed': expandedChart !== null && expandedChart !== 0}">
                    <div class="chart-header">
                        <div class="dropdown-trigger">
                            <button
                                mat-icon-button
                                class="action-info-btn"
                                [attr.aria-label]="avgCaseCycleTimeEntityType === 'account' ? 'How average cycle time is calculated for account' : 'How average cycle time is calculated for team member'"
                                matTooltipPosition="below"
                                matTooltipClass="chart-info-tooltip"
                                [matTooltip]="avgCaseCycleTimeEntityType === 'account' ? averageCycleTimeAccountTooltip : averageCycleTimeTeamMemberTooltip"
                            >
                                <mat-icon>info_outline</mat-icon>
                            </button>
                            <span class="title-text">Average Cycle Time &ndash;</span>
                            <mat-select class="dropdown" [value]="avgCaseCycleTimeEntityType" (selectionChange)="onAvgCaseCycleTimeEntityTypeChange($event.value)">
                                <mat-option value="account">Account</mat-option>
                                <mat-option value="teamMember">Team Member</mat-option>
                            </mat-select>
                        </div>
                    </div>
                    <button
                        mat-icon-button
                        class="expand-btn"
                        [matTooltip]="expandedChart === 0 ? 'Collapse' : 'Expand'"
                        (click)="toggleExpand(0)"
                        [attr.aria-label]="expandedChart === 0 ? 'Collapse' : 'Expand'"
                    >
                        <mat-icon>{{ expandedChart === 0 ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
                    </button>
                    <button
                        mat-icon-button
                        class="reset-btn"
                        matTooltip="Reset"
                        (click)="resetCaseAvgCycleTimeLegendSelections()"
                        [disabled]="!hasHiddenCaseAvgCycleTimeLegendItems()"
                    >
                        <mat-icon>cached</mat-icon>
                    </button>
                    <avg-case-cycle-time-line-chart
                        *ngIf="avgCaseCycleTime6Months.length > 0"
                        #caseAvgCycleTimeChart
                        [avgCaseCycleTime6Months]="avgCaseCycleTime6Months"
                        [isExpanded]="expandedChart === 0"
                    ></avg-case-cycle-time-line-chart>
                    <div *ngIf="avgCaseCycleTime6Months.length === 0" class="chart-empty-state text-center text-muted">
                        <img src="./assets/images/no-data-placeholder.png" alt="" class="pb-3" />
                        <h6>No Data Found</h6>
                    </div>
                </mat-card>
                <!-- SLA Adherence Chart -->
                <mat-card class="team-performance-chart" [ngClass]="{'expanded': expandedChart === 1, 'collapsed': expandedChart !== null && expandedChart !== 1}">
                    <div class="chart-header">
                        <div class="dropdown-trigger">
                            <button
                                mat-icon-button
                                class="sla-info-btn"
                                [attr.aria-label]="caseSlaAdherenceEntityType === 'queue' ? 'How SLA adherence is calculated for queue' : 'How SLA adherence is calculated for team member'"
                                matTooltipPosition="below"
                                matTooltipClass="chart-info-tooltip"
                                [matTooltip]="caseSlaAdherenceEntityType === 'queue' ? slaAdherenceQueueTooltip : slaAdherenceTeamMemberTooltip"
                            >
                                <mat-icon>info_outline</mat-icon>
                            </button>
                            <span class="title-text">SLA adherence &ndash;</span>
                            <mat-select class="dropdown" [value]="caseSlaAdherenceEntityType" (selectionChange)="onCaseSlaAdherenceEntityTypeChange($event.value)">
                                <mat-option value="queue">Queue</mat-option>
                                <mat-option value="teamMember">Team Member</mat-option>
                            </mat-select>
                        </div>
                        <div class="timeframe-subtitle">Last 6 Months</div>
                    </div>
                    <button
                        mat-icon-button
                        class="expand-btn"
                        [matTooltip]="expandedChart === 1 ? 'Collapse' : 'Expand'"
                        (click)="toggleExpand(1)"
                        [attr.aria-label]="expandedChart === 1 ? 'Collapse' : 'Expand'"
                    >
                        <mat-icon>{{ expandedChart === 1 ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
                    </button>
                    <case-sla-adherence-chart
                        *ngIf="caseSlaAdherenceData.length > 0"
                        [slaAdherenceData]="caseSlaAdherenceData"
                        [isExpanded]="expandedChart === 1"
                        [showSlaInHours]="caseSlaAdherenceEntityType === 'queue'"
                    ></case-sla-adherence-chart>
                    <div *ngIf="caseSlaAdherenceData.length === 0" class="chart-empty-state text-center text-muted">
                        <img src="./assets/images/no-data-placeholder.png" alt="" class="pb-3" />
                        <h6>No Data Found</h6>
                    </div>
                </mat-card>
                <!-- Average Cycle Time Per Queue Chart -->
                <mat-card class="team-performance-chart" [ngClass]="{'expanded': expandedChart === 2, 'collapsed': expandedChart !== null && expandedChart !== 2}">
                    <div class="chart-header">
                        <div class="dropdown-trigger">
                            <button
                                mat-icon-button
                                class="action-info-btn"
                                aria-label="How average cycle time is calculated for queue"
                                matTooltipPosition="below"
                                matTooltipClass="chart-info-tooltip"
                                [matTooltip]="averageCycleTimeQueueTooltip"
                            >
                                <mat-icon>info_outline</mat-icon>
                            </button>
                            <span class="title-text">Average Cycle Time &ndash; Queue</span>
                        </div>
                    </div>
                    <mat-button-toggle-group
                        class="chart-view-toggle"
                        hideSingleSelectionIndicator
                        [value]="caseAvgCycleTimePerQueueChartType"
                        (change)="setAvgCycleTimePerQueueChartType($event.value)"
                    >
                        <mat-button-toggle class="toggle-btn" value="line">LINE</mat-button-toggle>
                        <mat-button-toggle class="toggle-btn" value="bar">BAR</mat-button-toggle>
                    </mat-button-toggle-group>
                    <button
                        mat-icon-button
                        class="expand-btn"
                        [matTooltip]="expandedChart === 2 ? 'Collapse' : 'Expand'"
                        (click)="toggleExpand(2)"
                        [attr.aria-label]="expandedChart === 2 ? 'Collapse' : 'Expand'"
                    >
                        <mat-icon>{{ expandedChart === 2 ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
                    </button>
                    <button
                        mat-icon-button
                        class="reset-btn"
                        matTooltip="Reset"
                        (click)="resetCaseQueueLegendSelections()"
                        [disabled]="!hasHiddenCaseQueueLegendItems()"
                    >
                        <mat-icon>cached</mat-icon>
                    </button>
                    <div class="queue-view-content" *ngIf="caseQueueCycleTimes.length > 0">
                        <div class="queue-view-panel" [class.active]="caseAvgCycleTimePerQueueChartType === 'line'" [class.inactive]="caseAvgCycleTimePerQueueChartType !== 'line'">
                            <case-cycle-time-per-queue-line-chart
                                #caseCycleTimePerQueueLineChart
                                [isExpanded]="expandedChart === 2"
                                [queueCycleTimes]="caseQueueCycleTimes"
                            ></case-cycle-time-per-queue-line-chart>
                        </div>
                        <div class="queue-view-panel" [class.active]="caseAvgCycleTimePerQueueChartType === 'bar'" [class.inactive]="caseAvgCycleTimePerQueueChartType !== 'bar'">
                            <case-cycle-time-per-queue-grouped-bar-chart
                                #caseCycleTimePerQueueBarChart
                                [isExpanded]="expandedChart === 2"
                                [queueCycleTimes]="caseQueueCycleTimes"
                            ></case-cycle-time-per-queue-grouped-bar-chart>
                        </div>
                    </div>
                    <div *ngIf="caseQueueCycleTimes.length === 0" class="chart-empty-state text-center text-muted">
                        <img src="./assets/images/no-data-placeholder.png" alt="" class="pb-3" />
                        <h6>No Data Found</h6>
                    </div>
                </mat-card>
            </div>
        </mat-tab>
        <mat-tab label="Tasks">
            <div class="team-performance-tab">
                <!-- Task Cycle Time Heat Map (tasks x months) -->
                <mat-card class="team-performance-chart heat-card" [ngClass]="{'expanded': expandedChart === 3, 'collapsed': expandedChart !== null && expandedChart !== 3}">
                    <div class="chart-header">
                        <div class="dropdown-trigger">
                            <button
                                mat-icon-button
                                class="action-info-btn"
                                aria-label="How average task cycle time is calculated"
                                matTooltipPosition="below"
                                matTooltipClass="chart-info-tooltip"
                                [matTooltip]="averageTaskCycleTimeTooltip"
                            >
                                <mat-icon>info_outline</mat-icon>
                            </button>
                            <span class="title-text">Task Cycle Time Heat Map</span>
                        </div>
                    </div>
                    <button
                        mat-icon-button
                        class="expand-btn"
                        [matTooltip]="expandedChart === 3 ? 'Collapse' : 'Expand'"
                        (click)="toggleExpand(3)"
                        [attr.aria-label]="expandedChart === 3 ? 'Collapse' : 'Expand'"
                    >
                        <mat-icon>{{ expandedChart === 3 ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
                    </button>
                    <button
                        mat-icon-button
                        class="reset-btn"
                        matTooltip="Reset"
                        (click)="resetTaskHeatMapSort()"
                        [disabled]="!hasActiveTaskHeatMapSort()"
                    >
                        <mat-icon>cached</mat-icon>
                    </button>
                    <task-cycle-time-heat-map
                        *ngIf="taskCycleTimeByTaskSeries.length > 0"
                        #taskHeatMap
                        [isExpanded]="expandedChart === 3"
                        [series]="taskCycleTimeByTaskSeries"
                        [monthLabels]="taskCycleTimeByTaskMonthLabels"
                    ></task-cycle-time-heat-map>
                    <div *ngIf="taskCycleTimeByTaskSeries.length === 0" class="chart-empty-state text-center text-muted">
                        <img src="./assets/images/no-data-placeholder.png" alt="" class="pb-3" />
                        <h6>No Data Found</h6>
                    </div>
                </mat-card>
                <!-- Average Task Cycle Time by Task (bar) -->
                <mat-card class="team-performance-chart" [ngClass]="{'expanded': expandedChart === 4, 'collapsed': expandedChart !== null && expandedChart !== 4}">
                    <div class="chart-header">
                        <div class="dropdown-trigger">
                            <button
                                mat-icon-button
                                class="action-info-btn"
                                aria-label="How average task cycle time is calculated"
                                matTooltipPosition="below"
                                matTooltipClass="chart-info-tooltip"
                                [matTooltip]="averageTaskCycleTimeTooltip"
                            >
                                <mat-icon>info_outline</mat-icon>
                            </button>
                            <span class="title-text">Average Task Cycle Time &ndash;</span>
                            <mat-select class="dropdown" [value]="taskCycleTimeChartType" (selectionChange)="setTaskCycleTimeChartType($event.value)">
                                <mat-option value="byTask">Task</mat-option>
                                <mat-option value="byMonth">Month</mat-option>
                            </mat-select>
                        </div>
                    </div>
                    <button
                        mat-icon-button
                        class="expand-btn"
                        [matTooltip]="expandedChart === 4 ? 'Collapse' : 'Expand'"
                        (click)="toggleExpand(4)"
                        [attr.aria-label]="expandedChart === 4 ? 'Collapse' : 'Expand'"
                    >
                        <mat-icon>{{ expandedChart === 4 ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
                    </button>
                    <button
                        mat-icon-button
                        class="reset-btn"
                        matTooltip="Reset"
                        (click)="resetTaskCycleTimeLegendSelections()"
                        [disabled]="!hasHiddenTaskCycleTimeLegendItems()"
                    >
                        <mat-icon>cached</mat-icon>
                    </button>
                    <div class="queue-view-content" *ngIf="taskCycleTimeByTaskSeries.length > 0">
                        <div class="queue-view-panel" [class.active]="taskCycleTimeChartType === 'byTask'" [class.inactive]="taskCycleTimeChartType !== 'byTask'">
                            <task-six-month-bar-chart
                                #taskSixMonthChart
                                [isExpanded]="expandedChart === 4"
                                [series]="taskCycleTimeByTaskSeries"
                                [monthLabels]="taskCycleTimeByTaskMonthLabels"
                            ></task-six-month-bar-chart>
                        </div>
                        <div class="queue-view-panel" [class.active]="taskCycleTimeChartType === 'byMonth'" [class.inactive]="taskCycleTimeChartType !== 'byMonth'">
                            <task-cycle-time-bar-chart
                                #taskByMonthChart
                                [isExpanded]="expandedChart === 4"
                                [series]="taskCycleTimeByTaskSeries"
                                [monthLabels]="taskCycleTimeByTaskMonthLabels"
                                [showXAxisLabels]="true"
                                [showLegend]="true"
                            ></task-cycle-time-bar-chart>
                        </div>
                    </div>
                    <div *ngIf="taskCycleTimeByTaskSeries.length === 0" class="chart-empty-state text-center text-muted">
                        <img src="./assets/images/no-data-placeholder.png" alt="" class="pb-3" />
                        <h6>No Data Found</h6>
                    </div>
                </mat-card>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>